import React, { useEffect, useState } from "react";
import styled from "styled-components";
import FinancialDetailsFields from "../../../constants/DeliveryDrivers/FinancialDetailsFields.json";
import Input from "sushiweb/InputTypes/Input";
import variables from "../../../constants/assets/variables";
import {
  capitalizeFirstLetter,
  getObjectsDifference,
  getPath,
  getReadableDateTime,
  isObjectAllEntriesPresent,
  setNestedKeyValue,
} from "../../../utils";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import OTPModalWithPhoneNumber from "../../Common/OTPModalWithPhoneNumber";
import * as UserActions from "../../../store/actions/User";
import ErrorMsgs from "../../../constants/Errors.json";
import ErrorModal from "../../Common/ErrorModal";
import {
  FieldsContainer,
  Pill,
  FieldsSection,
} from "../../../constants/assets/containers";
import Button from "sushiweb/Button/Button";
import moment from "moment";
import { handleValidations } from "../utils";

const DriverFinancialDetails = ({
  editState,
  driverFinancialDetails,
  getDriverFinancialDetails,
  saveState,
  updateDriverFinancialDetails,
  setStatus,
  setSaveState,
  getOTPDriverFinancialDetails,
  driverBankStatus,
  getDriverBankVerificationStatus,
  verifyDriverBankDetails,
  driverBasicDetails,
}) => {
  const { id } = useParams();
  const [initialState, setInitialState] = useState({});
  const [otpModal, setOtpModal] = useState(false);
  const [updatedPhoneNo, setUpdatedPhoneNo] = useState("");
  const [errors, setErrors] = useState([]);

  const getValue = (field) => {
    if (field.dateField) {
      return getReadableDateTime(getPath(initialState, field.key, ""));
    } else if (field.isNumber) {
      return getPath(initialState, field.key, "");
    } else
      return capitalizeFirstLetter(getPath(initialState, field.key, "") + "");
  };

  const handleChange = (key, val, isNumber, isDateField) => {
    const values = { ...initialState };
    let finalVal = val;
    if (isNumber === true && finalVal) {
      finalVal = parseInt(finalVal);
    }
    if (isDateField === true && finalVal) {
      finalVal = moment.utc(finalVal.toLocaleString()).format();
    }
    setNestedKeyValue(values, key, finalVal);
    setInitialState(values);
  };

  const handleSubmit = () => {
    const payload = getObjectsDifference(
      driverFinancialDetails,
      initialState,
      "id"
    );
    const validationErrors = handleValidations(
      initialState, //to check all mandatory fields errors even if that field is not touched by the user
      "financialDetails",
      driverBasicDetails
    );
    if (Object.keys(payload).length > 0 && validationErrors.length === 0) {
      if (payload.nominee) {
        payload.nominee = {
          ...payload.nominee,
          driver_phone_no: driverBasicDetails.phone_no,
          nominee_for: "INSURANCE",
        };
      }
      updateDriverFinancialDetails(id, payload, initialState).then((res) => {
        if (res) {
          if (getPath(res, "status.code", undefined) === 897) {
            setStatus({
              type: "error",
              message: ErrorMsgs.OTP_REQUIRED,
            });
            setOtpModal(true); //show otp modal and make getotp call
            setTimeout(
              () =>
                getOTPDriverFinancialDetails(id, payload).then((res) =>
                  setUpdatedPhoneNo(getPath(res, "OTP.sent_to", undefined))
                ),
              1000
            );
          }
        }
      });
    } else if (Object.keys(payload).length === 0) {
      if (validationErrors.length > 0) {
        setErrors(validationErrors);
      } else {
        const err = [...errors];
        err.push("Error! You didn't make any change");
        setErrors(err);
      }
    } else {
      setErrors(validationErrors);
    }
    setSaveState(false);
  };

  const handleCloseOTPModal = () => {
    setOtpModal(false);
  };

  const handleOTPVerify = (otp) => {
    //make update call with otp
    const payload = getObjectsDifference(
      driverFinancialDetails,
      initialState,
      "id"
    );
    if (payload.nominee) {
      payload.nominee = {
        ...payload.nominee,
        driver_phone_no: driverBasicDetails.phone_no,
        nominee_for: "INSURANCE",
      };
    }
    updateDriverFinancialDetails(id, payload, initialState, otp).then((res) => {
      if (res) {
        handleCloseOTPModal();
        setSaveState(false);
        setUpdatedPhoneNo("");
      }
    });
  };

  const getOTP = () => {
    // make post call to get otp
    const payload = getObjectsDifference(
      driverFinancialDetails,
      initialState,
      "id"
    );
    getOTPDriverFinancialDetails(id, payload, true);
  };

  const handleErrorModalSubmit = () => {
    setErrors([]);
  };

  const handleBankVerification = (e) => {
    e.preventDefault();
    const payload = {
      account_no: getPath(initialState, "financial_details.account_no", ""),
      ifsc_code: getPath(initialState, "financial_details.ifsc_code", ""),
      name: getPath(driverBasicDetails, "name", ""),
      phone_no: getPath(driverBasicDetails, "phone_no", ""),
    };
    if (isObjectAllEntriesPresent(payload)) {
      verifyDriverBankDetails(id, payload);
    } else {
      setStatus({
        type: "error",
        message: "One of account no, ifsc code, name or phone no is missing",
      });
    }
  };

  const rollBackInitialState = () => {
    const activeDetailsCopy = JSON.parse(
      JSON.stringify(driverFinancialDetails)
    );
    setInitialState(activeDetailsCopy);
  };

  useEffect(() => {
    if (Object.keys(driverFinancialDetails).length === 0) {
      getDriverFinancialDetails(id);
    }
  }, []);

  useEffect(() => {
    rollBackInitialState();
    if (
      Object.keys(driverBankStatus).length === 0 &&
      Object.keys(driverFinancialDetails).length > 0
    ) {
      const payload = {
        account_no: getPath(
          driverFinancialDetails,
          "financial_details.account_no",
          ""
        ),
        ifsc_code: getPath(
          driverFinancialDetails,
          "financial_details.ifsc_code",
          ""
        ),
      };
      isObjectAllEntriesPresent(payload) &&
        getDriverBankVerificationStatus(id, payload);
    }
  }, [driverFinancialDetails]);

  //to handle click on save button
  useEffect(() => {
    saveState && handleSubmit();
  }, [saveState]);

  //to handle click on cancel button
  useEffect(() => {
    !editState && rollBackInitialState();
  }, [editState]);

  const getDropdownVal = (value, options, field) => {
    if (!field.labelKey || !field.valueKey) {
      return value;
    }
    const selectedOption = options.find(
      (item) => item[field.valueKey] === value
    );
    return field && selectedOption && selectedOption[field.labelKey];
  };

  const getField = (type, field) => {
    switch (type) {
      case "text":
        return (
          <Input
            borderColor={variables.primaryColor}
            id="sushi-input"
            data-testid={field.id}
            fullWidth={true}
            disabled={editState && field.disabled}
            onChange={(e) => handleChange(field.key, e, field.isNumber)}
            value={field.value || getValue(field)}
          />
        );
      case "calender":
        return (
          <Input
            id="sushi-input"
            className="calender-input"
            data-testid={field.id}
            fullWidth={true}
            disabled={editState && field.disabled}
            onChange={(e) => handleChange(field.key, e)}
            value={moment(getPath(initialState, field.key, "")).format(
              "YYYY-MM-DD"
            )}
            type="date"
            onChange={(val) =>
              handleChange(field.key, val, field.isNumber, field.dateField)
            }
          />
        );
      case "pill":
        return driverBankStatus[field.key] ? (
          <Pill>{driverBankStatus[field.key]}</Pill>
        ) : (
          ""
        );
      case "dropdown":
        return (
          <PaginatedReactDropdown
            options={field.options}
            disabled={field.disabled}
            labelKey={field.labelKey}
            valueKey={field.valueKey}
            value={getDropdownVal(
              getPath(initialState, field.key, ""),
              field.options,
              field
            )}
            handleChange={handleChange}
            placeholder=""
            keyToChange={field.key}
            showCross={true}
            id={`driverFinancialDetailsDropdown${field.labelKey}`}
          />
        );
    }
  };

  return (
    <DriverFinancialDetailsContainer
      editState={editState}
      className={!editState && "no-edit"}
    >
      {FinancialDetailsFields.sections.map((section, index) => {
        return (
          <FieldsSection key={index}>
            {section.name && <p>{section.name}</p>}
            <FieldsContainer className="fields-container">
              {section.fields.map((field, fieldIdx) => {
                return (
                  <React.Fragment>
                    <FieldHolder noBorder={field.noBorder} justify="flex-start">
                      {field.placeholder && (
                        <span>
                          {field.placeholder}
                          {field.isMandatory && <sup>*</sup>}
                        </span>
                      )}
                      {getField(field.type, field)}
                    </FieldHolder>
                    {field.note && (
                      <p className="mb-10 note-field">{field.note}</p>
                    )}
                  </React.Fragment>
                );
              })}
              {section.key === "bank_verification_status" && (
                <Button
                  onClick={handleBankVerification}
                  className="sushi-btn mt-20 mb-20"
                  appearance="outline"
                >
                  Verify Bank Details
                </Button>
              )}
            </FieldsContainer>
          </FieldsSection>
        );
      })}
      {otpModal && (
        <OTPModalWithPhoneNumber
          handleOTPVerify={handleOTPVerify}
          getOTP={getOTP}
          handleClose={handleCloseOTPModal}
          heading="Verify OTP to update details"
          phone={updatedPhoneNo}
        />
      )}
      {errors.length > 0 && (
        <ErrorModal
          handleSubmit={handleErrorModalSubmit}
          heading="Error while saving"
          errors={errors}
        />
      )}
    </DriverFinancialDetailsContainer>
  );
};

const DriverFinancialDetailsContainer = styled(DriverBasicDetailsContainer)`
  .fields-container {
    padding-bottom: 20px !important;
  }
`;

function mapStateToProps(state) {
  const { DeliveryDrivers } = state;
  return {
    driverFinancialDetails: DeliveryDrivers.driverFinancialDetails,
    driverBankStatus: DeliveryDrivers.driverBankStatus,
    driverBasicDetails: DeliveryDrivers.driverBasicDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverFinancialDetails: bindActionCreators(
      DeliveryDriversActions.getDriverFinancialDetails,
      dispatch
    ),
    updateDriverFinancialDetails: bindActionCreators(
      DeliveryDriversActions.updateDriverFinancialDetails,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getOTPDriverFinancialDetails: bindActionCreators(
      DeliveryDriversActions.getOTPDriverFinancialDetails,
      dispatch
    ),
    verifyDriverBankDetails: bindActionCreators(
      DeliveryDriversActions.verifyDriverBankDetails,
      dispatch
    ),
    getDriverBankVerificationStatus: bindActionCreators(
      DeliveryDriversActions.getDriverBankVerificationStatus,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverFinancialDetails);
